import { useEffect, useRef } from 'react';

import { IS_DEVELOPMENT } from 'constants/envs';

/**
 * A custom hook that ensures the effect only runs once in development with React Strict Mode.
 * This is particularly useful for effects that should only run once (like data fetching)
 * but get triggered twice in development due to Strict Mode's intentional double-invocation.
 *
 * @param effect - The effect callback to run once
 * @param deps - The dependencies array, similar to useEffect
 */

export const useEffectSafeStrictMode = IS_DEVELOPMENT
  ? (effect, deps) => {
      const isMountedRef = useRef(false);

      useEffect(() => {
        if (isMountedRef.current === false) {
          isMountedRef.current = true;

          return;
        }

        return effect();
      }, deps);
    }
  : useEffect;
